import { AiFillCheckCircle } from 'react-icons/ai';
import DrawerButton from '../Button/DrawerButton';
import Image from 'next/legacy/image';
import Link from 'next/link';

type Props = {
  dark?: boolean;
  installer: string;
  rating: string | number;
  count: string | number;
  imageUrl: string;
};

export default function InstallerHeaderSection({
  dark,
  installer,
  imageUrl,
  count,
  rating,
}: Props) {
  const filledStars = Array.from(
    { length: Math.round(Number(rating)) },
    (_, i) => i
  );
  const emptyStars = Array.from(
    { length: 5 - Math.round(Number(rating)) },
    (_, i) => i
  );
  return (
    <div className={`relative ${dark ? 'bg-blue-500' : 'bg-white'}`}>
      <div className="relative px-4 py-8 mx-auto max-w-7xl sm:py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between mx-8 md:mx-16">
          <div className="mb-8 sm:mb-0 sm:mr-8">
            <h1
              className={`text-3xl md:text-5xl font-bold capitaliz text-center md:text-left ${
                dark ? 'text-white' : 'text-gray-900'
              }  sm:text-4xl sm:tracking-tight lg:text-5xl`}
            >
              Solar Installer Reviews
            </h1>
            <div className="flex justify-center md:justify-start">
              <div className="flex flex-col md:flex-row">
                <div className="w-44 h-44 md:w-32 md:h-32 relative bg-white shadow-sm rounded-md mx-auto md:mx-0 mt-2 p-2">
                  <Image
                    src={imageUrl}
                    width={44} // Set the width to match the container's width
                    height={44} // Set the height to match the container's height
                    layout="responsive"
                    objectFit="contain" // Use "contain" to fit the entire image within the container
                    className="rounded-md pt-2"
                    alt={installer}
                  />
                </div>

                <div className="flex flex-col mt-2">
                  <h2
                    className={`text-2xl md:text-4xl font-bold capitalize text-center ${
                      dark ? 'text-white' : 'text-gray-900'
                    } sm:text-5xl sm:tracking-tight lg:text-4xl mt-2 pl-2 mb-2`}
                  >
                    {installer} Review
                  </h2>

                  <div className="flex space-x-1 justify-center md:justify-start ml-2 text-white">
                    <h3 className="text-2xl ">{rating}</h3>
                    {filledStars.map((_, i) => (
                      <span key={i} className="text-yellow-400 text-2xl mb-1">
                        ★
                      </span>
                    ))}
                    {emptyStars.map((_, i) => (
                      <span key={i} className="text-gray-50 text-2xl">
                        ★
                      </span>
                    ))}
                  </div>

                  <p className="ml-2 text-slate-50 font-medium underline text-center md:text-left">
                    <Link href={'#reviews'} legacyBehavior>
                      {count + ' Reviews'}
                    </Link>
                  </p>
                </div>
              </div>
            </div>{' '}
          </div>

          <div className="bg-white md:px-12 py-6 rounded-3xl w-full md:w-96 mx-auto text-center">
            <h3 className="text-2xl font-semibold mb-4">
              Maximize your solar <br />
              savings with:
            </h3>
            <div className="text-left space-y-4 px-8 ">
              <div className="flex items-center ml-4">
                <AiFillCheckCircle className="text-primary text-xl" />
                <p className="ml-3 font-medium">Personalized quotes</p>
              </div>
              <div className="flex items-center ml-4">
                <AiFillCheckCircle className="text-primary text-xl" />
                <p className="ml-3 font-medium">Pre-vetted installers</p>
              </div>
              <div className="flex items-center ml-4">
                <AiFillCheckCircle className="text-primary text-xl" />
                <p className="ml-3 font-medium">Better product & prices</p>
              </div>
            </div>
            <div className="pt-4 sm:pt-8 px-9 md:px-12">
              <DrawerButton />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
